import { createFileRoute, useSearch } from '@tanstack/react-router';
import { SignUp } from '@clerk/clerk-react';

export const Route = createFileRoute('/sign-up/$')({
  component: SignUpPage,
  validateSearch: (search: Record<string, unknown>) => ({
    redirect_url: (search.redirect_url as string) || undefined,
  }),
});

function SignUpPage() {
  const { redirect_url } = useSearch({ from: '/sign-up/$' });

  // If redirect_url is external (different origin), use it as forceRedirectUrl
  // Clerk will handle the redirect after successful sign-up
  const isExternalRedirect =
    redirect_url?.startsWith('http') &&
    !redirect_url?.includes('landing.app.banqora.com');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        paddingTop: 'clamp(2rem, 10vw, 5rem)',
        width: '100%',
      }}
    >
      <SignUp
        forceRedirectUrl={isExternalRedirect ? redirect_url : undefined}
        fallbackRedirectUrl="/"
      />
    </div>
  );
}
